export enum StaffPermissionsCategory {
  management = 1,
  marketing = 3,
  roomStaff = 4,
  aaddStaff = 5
}
